module.exports = __webpack_public_path__ + "img/category-alat-berat.6b440518.svg";